export function extractStringEnvVar(key: keyof NodeJS.ProcessEnv): string {
  const value = process.env[key]

  if (value === undefined) {
    const message = `The environment variable "${key}" cannot be "undefined".`

    throw new Error(message)
  }

  return value
}

export const WORD_COUNT = parseInt(extractStringEnvVar('REACT_APP_WORD_COUNT'))

export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!
